module.exports = __webpack_public_path__ + "img/maker_oetiker.bc78e454.jpg";